// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fvde","colMin":"styles_colMin__2T4lF"};